import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Input, BlockHeader, Button } from '@teko/ui';
import { OrderBy } from '../../types.es.js';
import { JDDropdown } from '../../Common/JDDropdown/JDDropdown.es.js';
import { SelectOption } from '../../Common/SelectOption/SelectOption.es.js';
import { ActivatedFilters } from '../../Listing/Filter/components/ActivatedFilters.es.js';

const Wrapper = styled.div`
  background: #fff;
`;
const Filter = styled.div(({ isMobile }) => `
  ${isMobile ? `overflow-y: hidden;
      display: flex;
      gap: 5px;
      margin-bottom: 8px
      ` : `
    padding: 0 1rem 0.5rem 1rem;
      display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr 1fr 1fr;
  height: 84px;`}
`);
const StyledMiniDropdown = styled(JDDropdown)`
  .dropdown-content {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  ${({ isMobile }) => isMobile ? `.dropdown-button {
    width: max-content;
  }` : ""}
`;
const Sort = styled.div(({ isMobile }) => `
  ${isMobile ? "" : "padding: 0.5rem 1rem;"}
  display: flex;
  justify-content: space-between;
  align-items: center;
`);
const SortTitle = styled.div`
  font-weight: 500;
  margin-right: 0.5rem;
`;
const StyledOption = styled(SelectOption)`
  padding: 0.365rem 0.75rem;
  cursor: pointer;
  color: ${(props) => props.isActive ? "#1435c3" : ""};
  &:hover {
    background: #f3f3f3;
  }
`;
const OptionName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const Search = styled(Input)(({ isMobile }) => `
  ${isMobile ? `` : `margin-left: 2rem;`}
  flex: 1;
  border-radius: ${isMobile ? "4px" : "999px"};
`);
const StyledTitle = styled.div`
  font-size: 20px;
  font-weight: 600px;
  line-height: 24px;
  margin-bottom: 8px;
`;
const BuildPcModalHeader = ({
  filters = [],
  onClickFilter,
  onClickSort,
  activeValues = [],
  searchParams,
  isMobile = false
}) => {
  const onKeyUp = (e) => {
    const keyword = e.target.value;
    if (e.keyCode === 13) {
      onClickFilter && onClickFilter("keyword", keyword || "");
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, !isMobile ? /* @__PURE__ */ React.createElement(BlockHeader, {
    content: /* @__PURE__ */ React.createElement(ActivatedFilters, {
      onClick: (value) => onClickFilter && onClickFilter(value.filterCode, value.optionCode),
      activeValues
    }),
    title: t("B\u1ED9 l\u1ECDc")
  }) : /* @__PURE__ */ React.createElement(StyledTitle, null, t("B\u1ED9 l\u1ECDc")), /* @__PURE__ */ React.createElement(Filter, {
    isMobile
  }, filters.map((filter, index) => {
    return /* @__PURE__ */ React.createElement(StyledMiniDropdown, {
      count: activeValues.filter((value) => value.filterCode === filter.code).length,
      key: index,
      text: filter.name,
      isMobile
    }, /* @__PURE__ */ React.createElement(React.Fragment, null, filter.options.map((value, index2) => /* @__PURE__ */ React.createElement(Button, {
      key: index2,
      link: true,
      variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === value.optionCode) !== -1 ? "primary" : "normal",
      onClick: () => onClickFilter && onClickFilter(filter.code, value.optionCode)
    }, value.optionName))));
  })), /* @__PURE__ */ React.createElement(Sort, {
    style: isMobile ? {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      gap: 8,
      marginBottom: "8px"
    } : void 0,
    isMobile
  }, /* @__PURE__ */ React.createElement(SortTitle, null, t("S\u1EAFp x\u1EBFp theo")), /* @__PURE__ */ React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      gap: isMobile ? 5 : 8
    }
  }, /* @__PURE__ */ React.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "quantity.last_3_month",
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("quantity.last_3_month", OrderBy.DESC)
  }, /* @__PURE__ */ React.createElement(OptionName, null, t("B\xE1n ch\u1EA1y"))), /* @__PURE__ */ React.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === OrderBy.ASC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", OrderBy.ASC)
  }, /* @__PURE__ */ React.createElement(OptionName, null, t("Gi\xE1 t\u0103ng d\u1EA7n"))), /* @__PURE__ */ React.createElement(StyledOption, {
    stickySize: "sm",
    isActive: searchParams && searchParams.sort === "bestPrice" && searchParams.order === OrderBy.DESC,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClickSort && onClickSort("bestPrice", OrderBy.DESC)
  }, /* @__PURE__ */ React.createElement(OptionName, null, t("Gi\xE1 gi\u1EA3m d\u1EA7n")))), /* @__PURE__ */ React.createElement(Search, {
    onKeyUp,
    placeholder: t("T\xECm linh ki\u1EC7n"),
    isMobile
  })));
};

export { BuildPcModalHeader };
